/**
 * Map from lowercase country name / alpha_id to Highcharts world topology `hc-key`.
 * Only common countries are listed; extend as needed. Anything not found falls
 * through to name-matching against the topology.
 */
export const COUNTRY_NAME_TO_HC_KEY: Record<string, string> = {
  'united states': 'us',
  'united states of america': 'us',
  usa: 'us',
  'united kingdom': 'gb',
  uk: 'gb',
  'great britain': 'gb',
  germany: 'de',
  france: 'fr',
  italy: 'it',
  spain: 'es',
  portugal: 'pt',
  netherlands: 'nl',
  belgium: 'be',
  luxembourg: 'lu',
  switzerland: 'ch',
  austria: 'at',
  ireland: 'ie',
  denmark: 'dk',
  sweden: 'se',
  norway: 'no',
  finland: 'fi',
  iceland: 'is',
  poland: 'pl',
  'czech republic': 'cz',
  czechia: 'cz',
  slovakia: 'sk',
  hungary: 'hu',
  romania: 'ro',
  bulgaria: 'bg',
  greece: 'gr',
  turkey: 'tr',
  russia: 'ru',
  ukraine: 'ua',
  belarus: 'by',
  estonia: 'ee',
  latvia: 'lv',
  lithuania: 'lt',
  canada: 'ca',
  mexico: 'mx',
  brazil: 'br',
  argentina: 'ar',
  chile: 'cl',
  colombia: 'co',
  peru: 'pe',
  venezuela: 've',
  uruguay: 'uy',
  paraguay: 'py',
  ecuador: 'ec',
  bolivia: 'bo',
  japan: 'jp',
  china: 'cn',
  'south korea': 'kr',
  korea: 'kr',
  'north korea': 'kp',
  india: 'in',
  pakistan: 'pk',
  bangladesh: 'bd',
  indonesia: 'id',
  malaysia: 'my',
  singapore: 'sg',
  thailand: 'th',
  vietnam: 'vn',
  philippines: 'ph',
  taiwan: 'tw',
  'hong kong': 'hk',
  australia: 'au',
  'new zealand': 'nz',
  'south africa': 'za',
  egypt: 'eg',
  nigeria: 'ng',
  kenya: 'ke',
  morocco: 'ma',
  algeria: 'dz',
  tunisia: 'tn',
  ethiopia: 'et',
  ghana: 'gh',
  'saudi arabia': 'sa',
  'united arab emirates': 'ae',
  uae: 'ae',
  qatar: 'qa',
  kuwait: 'kw',
  bahrain: 'bh',
  oman: 'om',
  jordan: 'jo',
  lebanon: 'lb',
  israel: 'il',
  iran: 'ir',
  iraq: 'iq',
  syria: 'sy',
  afghanistan: 'af',
  cyprus: 'cy',
  malta: 'mt',
  slovenia: 'si',
  croatia: 'hr',
  serbia: 'rs',
  'bosnia and herzegovina': 'ba',
  albania: 'al',
  'north macedonia': 'mk',
  macedonia: 'mk',
  montenegro: 'me',
  moldova: 'md',
  georgia: 'ge',
  armenia: 'am',
  azerbaijan: 'az',
  kazakhstan: 'kz',
  uzbekistan: 'uz',
  turkmenistan: 'tm',
  kyrgyzstan: 'kg',
  tajikistan: 'tj',
  mongolia: 'mn',
  'south sudan': 'ss',
  south_sudan: 'ss',
  kosovo: 'kv',
};
